/*
  Sticky header (sections/header.liquid).

  The header section sticks to the top of the page and never hides (D2, at every width since
  desktop-01).

  The island (d-57, assets/header.css "The island"): once the page has scrolled more than
  10px, .section-header--island goes on the section and the header gathers into an ink capsule; back
  at the top it comes off again. One class from the same passive scroll listener, reading only
  scrollY. .section-header--ready says this script runs: without it (no JavaScript, or the script
  failed), the header keeps its top look, and over a stage assets/header.css gives it the paper look
  after a few seconds.

  It also keeps the header's height in --header-height on the root, so focus and link targets
  clear the header (the page's scroll-padding-top, assets/base.css) and the stages keep its room.
*/
if (!customElements.get('sticky-header')) {
  customElements.define(
    'sticky-header',
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.section-header') || this;
        this.ticking = false;

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });

        // The header's own height: over a stage the section itself takes none. Follows the header's
        // size too, e.g. a logo that wraps the row on a narrow screen.
        this.resizeObserver = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
        });
        this.resizeObserver.observe(this);

        // A page opened part way down (a reload, back from another page) starts as the island.
        this.island(window.scrollY);
        this.section.classList.add('section-header--ready');
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        this.resizeObserver?.disconnect();
        this.section.classList.remove('section-header--ready', 'section-header--island');
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.island(window.scrollY);
        });
      }

      // The island's one class, at every width.
      island(scrollY) {
        this.section.classList.toggle('section-header--island', scrollY > 10);
      }
    }
  );
}
